import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[textOverflowY]',
  exportAs: 'textOverflowY',
  standalone: true,
})
export class TextOverflowYDirective implements AfterViewInit {
  value = true;

  constructor(
    private el: ElementRef,
  ) { }

  ngAfterViewInit(): void {
    const element = this.el.nativeElement;
    this.value = element.offsetHeight < element.scrollHeight;
  }
}
